import { render } from "./ModalOpenSupport.vue?vue&type=template&id=7afc09b7&scoped=true&ts=true"
import script from "./ModalOpenSupport.vue?vue&type=script&lang=ts"
export * from "./ModalOpenSupport.vue?vue&type=script&lang=ts"

import "./ModalOpenSupport.vue?vue&type=style&index=0&id=7afc09b7&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afc09b7"]])

export default __exports__